import type { Actor } from '@/entities/common'
import { getActorContactId } from '@/utils/actor/getActorContactId'
import { getActorUserId } from '@/utils/actor/getActorUserId'

export const getActorKey = (actor: Actor): string | null => {
    const userId = getActorUserId(actor)
    if (userId) return `user:${userId}`
    const contactId = getActorContactId(actor)
    return contactId ? `contact:${contactId.toString()}` : null
}
